import { FC, Fragment } from 'react';
import {
    PerformDateFilterSelector,
    PerformDateRangeFilterSelector,
    PerformEnumMultiSelect,
} from '../perform-indicator/perform-indicator';
import {
    JobStatus,
    CustomerFilterDto,
    CustomFieldsFilterDto,
    CustomFieldsFilterItem,
} from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface JobProps {
    segmentId: number;
    job: Partial<CustomerFilterDto>;
    customFields?: CustomFieldsFilterDto;
    CustomFieldsComponent?: FC<{
        segmentId: number;
        type: string;
        filters?: CustomFieldsFilterItem[];
    }>;
}

export const Job: FC<JobProps> = ({ segmentId, job, CustomFieldsComponent, customFields }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Job</div>
        <div>
            <PerformDateFilterSelector
                name="Last Completed Job Date"
                valueStatic={job.noJobsSince}
                valueDynamic={job.noJobsSinceRelative}
            />
            <PerformDateRangeFilterSelector
                name="Job Scheduled Date"
                valueStatic={job.jobScheduled}
                valueDynamic={job.jobScheduledRelative}
            />
            <PerformEnumMultiSelect
                name="Job Status"
                value={job.jobStatuses}
                enumType={JobStatus}
            />
            {CustomFieldsComponent && (
                <CustomFieldsComponent
                    segmentId={segmentId}
                    type="jobCustomFields"
                    filters={customFields?.filters}
                />
            )}
        </div>
    </Fragment>
);
